//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pdf from "vue-pdf";
export default {
  inject: ["$oss"],
  data() {
    return {
      loading: false,
      activeId: "",
      popup: false,
      writeEmail: false,
      email: "",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf", // 文件类型
      pdfSrc: "", // pdf文件地址
      pdfType: "", // 展示pdf类型
      downloadUrl: "",
      showPdfUrl: "",
      showPositionValue: false,
      errorMsg: ""
    };
  },
  components: { pdf },
  created() {
    this.pdfSrc = this.$route.params.pdfSrc;
    this.downloadUrl = this.$route.params.pdfSrc;
    // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
    this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
  },
  computed: {},
  async mounted() {
    this.activeId = this.$route.params.activeId;
    if (!this.activeId) {
      this.activeId = this.$route.params.id;
    }
    if (this.$route.params.pdfType && this.$route.params) {
      this.pdfType = this.$route.params.pdfType;
    }
    await this.glGetOssClient();
  },
  methods: {
    /**
     * 显示提示信息
     *
     */
    showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },
    /**
     * 返回首页
     *
     */
    goback() {
      this.$router.push({
        name: "loginSelect",
        params: { id: this.activeId }
      });
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
        // console.log(this.currentPage)
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
        // console.log(this.currentPage)
      }
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    },
    /** 
     * 手机预览
     */
    previewConfirm() {
      try {
        // 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
        const filename = '招商函.pdf' // filename为自定义下载后的文件名。
        const response = {
          'content-disposition': `attachment; filename=${encodeURIComponent(filename)}`
        }
        // object-key表示从OSS下载文件时需要指定包含文件后缀在内的完整路径，例如abc/efg/123.jpg。
        this.showPdfUrl = this.$oss.client.signatureUrl("meet/" + this.downloadUrl.split("/")[this.downloadUrl.split("/").length -1], {expires: 3600});
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf("micromessenger") != -1) {
          this.showMsg("请在其他浏览器点击该按钮");
          return;
        }
        window.open(this.showPdfUrl);
      } catch(err) {
        this.showMsg("文件下载异常");
        console.log(err)
        console.log("OSS配置获取异常");
      }
    },
    /** 
     * 取消发送按钮
     */
    cancelSend() {
      this.writeEmail = false;
      this.email = "";
    },
    /**
     * pdf发送邮箱
     */
    async send2Email() {
      let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!this.email) {
        this.showMsg("请输入邮箱地址");
        return;
      }
      if (!reg.test(this.email)) {
        this.showMsg("请输入正确的邮箱地址");
        return;
      }
      this.loading = true;
      const list = this.$apis.exhibition.sendEmail;
      const params = {
        email: this.email,
        certificateUrl: this.downloadUrl
      }
      try {
        const { data } = (await this.$axios.post(list, params)) || {};
        this.showMsg(data);
        this.writeEmail = false;
        this.popup = false;
        this.loading = false;
      } catch(err) {
        this.loading = false;
        this.showMsg(err||err.msg||err.data.msg);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pdfView.vue